import { AxiosError } from 'axios';

import { logToSentry } from 'src/services/sentry/logger';

const trackError = (title: string, error: Error | Parse.Error | AxiosError, data?: {}) =>
  logToSentry(error, data, 'error', title);

const Rollbar = {
  trackError
};

export default Rollbar;
